import Model from '@/models/Model'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'graduates',
            name: 'graduate',
            class: 'Modules\\Site\\Entities\\Graduate',

            dataTable: {
                headerTopComponents: [
                    {
                        component: 'graduates-import-component'
                    },
                    // {
                    //     component: 'graduates-export-component'
                    // }
                ]
            }
        }
    }
}